import { Logo as LogoTK } from '@tablekit/logo';
import * as React from 'react';
import { Link, useParams } from 'react-router-dom';

import { LogoWrapper } from 'components/MainLayout/styled';
import { Params } from 'utils/types';

export function Logo(): JSX.Element {
  const params = useParams<Params>();

  return (
    <Link to={`/${params.locale}`} aria-label="TableCheck link">
      <LogoWrapper className="animated slideInLeft delay-01s fast">
        <LogoTK
          isDarkTheme
          symbolSize="32px"
          wordingSize="200px"
          aria-label="TableCheck logo"
        />
      </LogoWrapper>
    </Link>
  );
}
